import { AlertColor } from "@mui/material"
import { Attributes } from "react"


export interface MenuState {
  isMenuOpen: boolean,
  currentMenu: string
}

export interface SplitMenuItem {
  Description: string,
  CallBackFn: any
}

export interface AppStateCommon {
  IsLoading: boolean,
  RequestCount: number
}

export interface TableInfo {
  Id: number,
  Description: string,
  Version: string,
  LastModified: string,
  IsGlobal: boolean,
  EditorType: EditorType,
  CanDeleteRows: boolean,
  MaxRowCount:number|null,
  MinRowCount:number|null,
  OpensInPopup: boolean|null,
  TicketType: number 
}

export enum EditorType {
  Acceptance = 1,
  Table = 2,
  Form = 3,
  TableOrForm = 4,
  BreakOfJourney = 5,
  TimeRestrcitions = 6,
  Language=7
}

export interface OutputTableInfo {
  Id: number,
  Name: string,
  Description: string,
  LastUpdated: string,
  IsGlobal: boolean,
  TicketType: number 
}

export interface NLCInfo {
  Id: number,
  NLC: string,
  StationName: string,
  SCUIpAddress:string|null
}

export interface StationUpdate{
  TocId:number|undefined,
  MagneticStationId:string|undefined,
  ItsoStationId:string|undefined,
  Station:NLCInfo
}

export interface DataAttribute {
  Name: string,
  Value: any
}

export interface FilterAttribute {
  Name: string,
  Value: any,
  DataType: number
}

export interface DataField {
  Name: string,
  Description?: string | undefined,
  ToolTip?:string|undefined,
  Type: string,
  DataType: number,
  IsBrowsable: boolean,
  IsEditable: boolean,
  IsNullable: boolean,
  IsUnique: boolean,
  IsMultiSelect: boolean,
  CustomFormat: string | null,
  FieldGroupOrderNo: number | null,
  FieldGroup: string | null,
  IsFilterField: boolean | null,
  IsDisableSectionField: boolean | null,
  GridSizeOutof12: number | null,
  MasterList: DropdownModel | null,
  ToggleField: string | null,
  ToggleCondition: boolean | null,
  LookUpShowIdDesc: boolean | null,
  CanFindAndReplace: boolean | null,
  FindAndReplaceOptionCount: number | null
  Min:number|null,
  Max:number|null,
  ValueInSecondaryTable:boolean,
  MergeGroup: string,
  ButtonField: string | null
}

export interface DataRow {
  UniqueIdValue: any,
  OldUniqueId: any,
  Attributes: DataAttribute[],
  IsDeleted:boolean
}
export interface MasterListDataOutput {
  MasterListId: number,
  Fields: DataField[],
  Rows: DataRow[],
  FieldLookups: {
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[],
  CanAddRows: boolean,
  CanDeleteRows: boolean,
  IsEditable:boolean

}

export interface DataOutput extends CommonDataOutput {
  TableId: number,
  Fields: DataField[],
  Rows: DataRow[],
  FieldLookups: {
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[],
  CanAddRows: boolean,
  CanDeleteRows: boolean

}

export interface TableDataOutput {
  Fields: DataField[],
  Rows: DataRow[]
}

export interface FormDataOutput extends CommonDataOutput {
  TableId: number,
  Fields: DataField[],
  FieldGroups: FieldGroup[],
  VersionDetails: VersionDetails,
  UniqueIdValue: any,
  OldUniqueId: any,
  FieldLookups: {
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[]
}

export interface LanguageDataOutout extends CommonDataOutput {
  TableId: number,
  DefaultTexts: DropdownModel[],
  TopLineItem: LineItem,
  BottomLineItem: LineItem,
  TypeLookUps:{
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[]
}

export interface LineItem{
  Id:number|undefined,
  Line:number|undefined,
  Type:number|undefined,
  LineTexts:DropdownModel[]
}

export interface BojDataOutout extends CommonDataOutput {
  TableId: number,
  BojItems: BojItem[],
  OriginGroups: number[],
  DestinationGroups: number[],
  BojGroups:BojGroup[]
  Nlcs:DropdownModel[]
}


export interface TimeRestrictionsOutput extends CommonDataOutput{
  TableId:number,
  RestrictionId:number,
  TravelSets:TravelSet[],
  RestrictionDays:{RestrictionId:number,DayTypeId:number}[],
  TimeRestrictions:TimeRestriction[],
  TypeLookUps:{
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[]
}

export interface TravelSet{
  Id:number,
  Group:number,
  Set:number
}

export interface TimeRestriction{
  Id:number,
  RestrictionId:number,
  Entry:number,
  Set:number,
  StartTime:number|null,
  EndTime:number|null
}


export interface BojItem {
  Id: number,
  Origin_Group: number,
  Dest_Group: number,
  Operation: number,
  Version:string,
  BwdCompatVersion:string|null
}

export interface BojGroup{
  Id:number,
  Nlc:string,
  BojGroup:number,
  Version:string,
  BwdCompatVersion:string|null
}

export interface FieldGroup {
  Description: string,
  Attributes: DataAttribute[]
}
export interface VersionDetails {
  UniqueIdValue: any,
  OldUniqueId: any,
  BackwardCompatibilityVersion: string | null
}

export interface SelectableItem {
  Id: number,
  Description: string,
  IsSelected: boolean,
  Type: number,
  SubType: number | null,
  IsChanged: boolean,
  IsDeleted:boolean,
  Version:string,
  BackwardCompatibilityVersion: string | null
}

export interface AcceptanceDataOutput extends CommonDataOutput {
  Fields: DataField[],
  SelectedItems: SelectableItem[],
  LookUpItems: DropdownModel[],
  TypeLookups: {
    FieldName: string,
    LookUpValues: DropdownModel[]
  }[]
}

export interface CommonDataOutput {
  Version: string,
  IsEditable :boolean,
  ReadOnlyUser:boolean
}
export interface LogItem {
  Id: number,
  Type: string,
  Icon: string,
  DateCreated: string,
  CreatedUser: string,
  Description: string,
  Remarks: string
}

export interface Menu {
  Id:number,
  Name: string,
  Description: string,
  Icon: string
}

export interface NotificationState {
  IsOpen: boolean,
  Message: string,
  Type: AlertColor
}

export interface DropdownModel {
  Id: string,
  Description: string
}

export interface MasterListItem {
  Id: string,
  Description: string,
  Type: string
}

export interface TableVersionItem {
  Id: string,
  Description: string,
  Type: string,
  Version:string
}

export interface UpdateMasterlistInput {
  

  MasterListId:number | undefined,
  TocId:number,
 InputData:DataAttribute
   
  }
